import React, { useEffect, useState, useContext } from "react";
import axios from '../../util/axios'
import { scrollToTop } from "../../util/functions";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import ActiveContext from "../../Context/Context";
import Layout from "../../Components/TopNav/Topnav";
import Loading from "../../Components/Loading/loading.component";
import {toast} from "react-toastify";
import {TabsControllerContext} from "../../Context/Tabs/TabsProvider";
const BookingWidget = () => {
    const query = new URLSearchParams(document.location.search);
    const navigate = useNavigate()
    const firstName = query.get('first_name');
    const lastName = query.get('last_name');
    const email = query.get('email');
    const phone = query.get('phone');
    const usiId = query.get('usiId');
    const [type, setType] = useState("");
    const [appointmentType, setAppointmentType] = useState('');
    const [bookingId, setBookingId] = useState('');
    const [loading, setLoading] = useState(true);
    const { clinicData } = useContext(ActiveContext);  
    const { pendingBooking } = useContext(TabsControllerContext);

    function openInNewTab(url, samePage) {
      if (samePage) {
        return window.open(url, "_self");
      }
      navigate(`/en/scan-cnfm-loading`);
      window.open(url, "_blank").focus();
    }
    
    const fetchClinicData = async () => {
        setLoading(true);
        if (clinicData) {
            const scheduleState =
                window.location.search.includes("proc_schedule=true");
            let body = {
                clinic_id: Cookies.get("clinic_id"),
                pendingBookingId: pendingBooking.id,
                user_scan_info_id: usiId,
                procedure_schedule: scheduleState,
            };
            try {
                const response = await axios.post(`admin/v1/clinic/reschedule`, body);
                if (response.status === 200) {
                    setType(response.data.type);
                    setAppointmentType(response.data.appointment_type);
                    setBookingId(response.data.booking_id);
                    window.addEventListener &&
                    window.addEventListener(
                        "message",
                        function (event) {
                            if (
                                event.origin ===
                                clinicData?.data?.clinic_info.youcanbookme_link
                            ) {
                                document.getElementById("ycbmiframenabih").style.height =
                                    event.data + "px";
                            }
                        },
                        false,
                    );

                    if (window !== "undefined") {
                        try {
                            window.scroll({
                                top: 0,
                                left: 0,
                                behavior: "smooth",
                            });
                        } catch (error) {
                            scrollToTop(0);
                        }
                    }
                }
            } catch (e) {
                console.log("error in checking booking status", e);
                toast.error("Error in checking booking status", 3000);
            } finally {
                setLoading(false);
            }
        }
    };

  useEffect(() => {
    void fetchClinicData();
  }, [clinicData]);
  
  const lang = 'en'
  const host = process.env.REACT_APP_HOST
  const port = process.env.REACT_APP_PORT

  useEffect(()=>{
    if(type && appointmentType) {
      if(type === 'reschedule') {
        if(bookingId){
          let url = `&HOST=${host}&LANG=${lang}&PORT=${port}&b=${bookingId}&or=${bookingId}&TYPE=${appointmentType}&PENDINGBOOKINGID=${pendingBooking.id}`;
          openInNewTab(`${clinicData?.data?.clinic_info?.youcanbookme_link}/?${url}`)
        }
      } else if (type === 'rebooking') {
        let url = `&HOST=${host}&LANG=${lang}&PORT=${port}&FNAME=${firstName}&LNAME=${lastName}&EMAIL=${email}&PHONE=${phone}&TYPE=${appointmentType}&PENDINGBOOKINGID=${pendingBooking.id}`;
        openInNewTab(`${clinicData?.data?.clinic_info?.youcanbookme_link}/?${url}`, true);
      }
    }
  }, [bookingId, type, appointmentType])
    
    if (loading) {
      return (
        <Layout>
            <Loading />
        </Layout>
      );
    }
};

export default BookingWidget;
 
